import SubcategoryDescription from './SubcategoryDescription'

export default SubcategoryDescription
// eslint-disable-next-line import/export
export * from './SubcategoryDescription'
